import { createContext } from 'react';
import { UniverseUIConfiguration } from '@tacans/shared-marketplace-layer';

export interface UniverseConfigurationsContextValue {
    configurations: UniverseUIConfiguration[];
    refetch?: () => void;
}

export const UniverseConfigurationsContext = createContext<UniverseConfigurationsContextValue>({
    configurations: []
});
